export const LOAD_USER_INFO = "LOAD_USER_INFO";
export const LOGOUT_USER = "LOGOUT_USER";